import { RateBoxDescription, RateBoxLink } from './elements';

import type { IRateOption } from 'modules/api-requests/rates/types';
import Text from 'antd/es/typography/Text';
import Tooltip from 'antd/es/tooltip';
import { GolfCardIcon } from '../../booking-details-page/players-info/player-info-blocks/icons/golf-card-icon';
import { GolfAssistantIcon } from '../../booking-details-page/players-info/player-info-blocks/icons/golf-assistant-icon';
import { GolfEquipmentIcon } from '../../booking-details-page/players-info/player-info-blocks/icons/golf-equipment-icon';
import { Col, Row } from 'antd/es';
import { PathCreator, RoutePaths } from 'routing/constants';

interface IMobileRateDescription {
  rate: {
    id: string;
    name: string;
    teeId: string;
    date: string;
    time: string;
    price: number | null;
    description: string;
    options: IRateOption[];
  };
  activeKey: string | null;
}

export const MobileRateDescription = ({
  rate: { id, date, time, description, teeId, options, price },
  activeKey,
}: IMobileRateDescription) => {
  const hasPrice = Boolean(price) || price === 0;
  return (
    <RateBoxDescription hidden={activeKey !== teeId + id}>
      <p>{description}</p>
      <Row wrap={false} justify="space-between" align="bottom">
        <Col>
          {options.length ? (
            <>
              <div>
                <Text strong>Rate includes:</Text>
              </div>
              {options.map((x) => {
                if (x.name.toLowerCase().indexOf('cart') >= 0)
                  return (
                    <Tooltip key={x.name} title={x.name}>
                      <GolfCardIcon />
                    </Tooltip>
                  );
                if (x.name.toLowerCase().indexOf('assistant') >= 0)
                  return (
                    <Tooltip key={x.name} title={x.name}>
                      <GolfAssistantIcon />
                    </Tooltip>
                  );
                if (x.name.toLowerCase().indexOf('golf') >= 0)
                  return (
                    <Tooltip key={x.name} title={x.name}>
                      <GolfEquipmentIcon />
                    </Tooltip>
                  );
                return null;
              })}
            </>
          ) : null}
        </Col>
        <Col>
          <RateBoxLink
            hidden={!hasPrice}
            to={hasPrice ? PathCreator[RoutePaths.BOOKING_DETAILS].getUrl({ date, time, rate: id }) : '/'}
          >
            Book Now
          </RateBoxLink>
        </Col>
      </Row>
    </RateBoxDescription>
  );
};

